import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import styles from './Bird.module.css';

function Bird() {
    const navigate = useNavigate();
    const [birds, setBirds] = useState([]);
    const [aviaries, setAviaries] = useState([]);
    const [cages, setCages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('Todos');
    const [genderFilter, setGenderFilter] = useState('Todos');
    const [categoryFilter, setCategoryFilter] = useState('Todos'); // 1. Novo Estado para o Filtro de Categoria
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    // Estados para os Modais de Seleção/Busca de Pais
    const [parentModalType, setParentModalType] = useState(null); // 'father' | 'mother' | null
    const [parentSearchTerm, setParentSearchTerm] = useState('');

    const initialFormState = {
        name: '',
        bird_band_right: '',
        bird_band_left: '',
        category: '',
        color: '',
        race: '',
        gender: 'undefined',
        birthday: '',
        aviaryId: '',
        birthing_cage: '',
        current_cage: '',
        father: '',
        mother: '',
        status: 'Ativo'
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        fetchInitialData();
    }, []);

    async function fetchInitialData() {
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem('token'));
            const headers = { Authorization: `Bearer ${token}` };

            const [birdsRes, aviariesRes, cagesRes] = await Promise.all([
                api.get('/bird/mybirds', { headers }).catch(() => ({ data: { birds: [] } })),
                api.get('/aviary/myaviarys', { headers }).catch(() => ({ data: { aviary: [] } })),
                api.get('/cage/mycages', { headers }).catch(() => ({ data: { cages: [] } }))
            ]);

            const loadedAviaries = aviariesRes.data.aviary || [];
            setBirds(birdsRes.data.birds || []);
            setAviaries(loadedAviaries);
            setCages(cagesRes.data.cages || []);

            if (loadedAviaries.length > 0) {
                setFormData(prev => ({ ...prev, aviaryId: loadedAviaries[0]._id }));
            }
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
        } finally {
            setLoading(false);
        }
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setErrorMessage('');

        try {
            const token = JSON.parse(localStorage.getItem('token'));

            const payload = {
                ...formData,
                birthday: formData.birthday ? new Date(formData.birthday).toISOString() : null,
                birthing_cage: formData.birthing_cage || null,
                current_cage: formData.current_cage || null,
                father: formData.father || null,
                mother: formData.mother || null
            };

            const response = await api.post('/bird/create', payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert(response.data.message || 'Pássaro cadastrado com sucesso!');
            setIsCreateModalOpen(false);
            
            setFormData({
                ...initialFormState,
                aviaryId: aviaries[0]?._id || ''
            });

            fetchInitialData();
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'Erro ao cadastrar ave.');
        }
    }

    const getGenderLabel = (gender) => {
        if (gender === 'male') return 'Macho';
        if (gender === 'female') return 'Fêmea';
        return 'Indefinido';
    };

    const getGenderIcon = (gender) => {
        if (gender === 'male') return '♂';
        if (gender === 'female') return '♀';
        return '?';
    };

    const getGenderClass = (gender) => {
        if (gender === 'male') return styles.male;
        if (gender === 'female') return styles.female;
        return styles.undefined || '';
    };

    // 2. Aplicação do filtro de Categoria na listagem
    const filteredBirds = birds.filter(bird => {
        const matchesSearch =
            bird.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            bird.bird_band_right?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            bird.bird_band_left?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            bird.race?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            bird.category?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus =
            statusFilter === 'Todos' || bird.status === statusFilter;

        const matchesGender =
            genderFilter === 'Todos' || bird.gender === genderFilter;

        const matchesCategory =
            categoryFilter === 'Todos' || bird.category === categoryFilter;

        return matchesSearch && matchesStatus && matchesGender && matchesCategory;
    });

    const maleBirdsOptions = birds.filter(bird => bird.gender === 'male');
    const femaleBirdsOptions = birds.filter(bird => bird.gender === 'female');

    const selectedFather = maleBirdsOptions.find(b => b._id === formData.father);
    const selectedMother = femaleBirdsOptions.find(b => b._id === formData.mother);

    const currentParentOptions = parentModalType === 'father' ? maleBirdsOptions : femaleBirdsOptions;
    const filteredParentOptions = currentParentOptions.filter(b => {
        const term = parentSearchTerm.toLowerCase();
        return (
            (b.name || '').toLowerCase().includes(term) ||
            (b.bird_band_right || '').toLowerCase().includes(term) ||
            (b.bird_band_left || '').toLowerCase().includes(term)
        );
    });

    const handleSelectParent = (id) => {
        if (parentModalType === 'father') {
            setFormData(prev => ({ ...prev, father: id }));
        } else if (parentModalType === 'mother') {
            setFormData(prev => ({ ...prev, mother: id }));
        }
        setParentModalType(null);
        setParentSearchTerm('');
    };

    if (loading) {
        return <p className={styles.loading}>Carregando aves...</p>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.top_header} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <span className={styles.badge_category}>PLANTEL</span>
                    <h1>Minhas aves</h1>
                    <p className={styles.subtitle}>Consulte as informações e genealogia.</p>
                </div>
                
                {/* Agrupador para colocar o botão ao lado esquerdo do contador */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <button 
                        className={styles.btn_add} 
                        onClick={() => setIsCreateModalOpen(true)}
                        style={{ 
                            display: 'inline-flex', 
                            flexDirection: 'column', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            lineHeight: '1.2'
                        }}
                    >
                        <span>+ Nova</span>
                        <span>Ave</span>
                    </button>
                    
                    <div className={styles.count_box}>
                        <span className={styles.count_number}>{filteredBirds.length}</span>
                        <span className={styles.count_label}>aves</span>
                    </div>
                </div>
            </div>

            <div className={styles.controls_row}>
                <div className={styles.search_input_wrapper}>
                    <span className={styles.search_icon}>🔍</span>
                    <input
                        type="text"
                        placeholder="Pesquisar por anilha, nome ou raça..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className={styles.filters_container} style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Filtro de Status */}
                    <div className={styles.status_filter_wrapper} style={{ flex: 1, minWidth: '140px' }}>
                        <h3>Status:</h3>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className={styles.status_select}
                            style={{ width: '100%' }}
                        >
                            <option value="Todos">Todos os status</option>
                            <option value="Ativo">Ativo</option>
                            <option value="Vendido">Vendido</option>
                            <option value="Falecido">Falecido</option>
                            <option value="Doado">Doado</option>
                        </select>
                    </div>

                    {/* Filtro de Sexo */}
                    <div className={styles.gender_filter_wrapper} style={{ flex: 1, minWidth: '140px' }}>
                        <h3>Sexo:</h3>
                        <select
                            value={genderFilter}
                            onChange={(e) => setGenderFilter(e.target.value)}
                            className={styles.status_select}
                            style={{ width: '100%' }}
                        >
                            <option value="Todos">Todos os sexos</option>
                            <option value="male">Macho ♂</option>
                            <option value="female">Fêmea ♀</option>
                            <option value="undefined">Indefinido ?</option>
                        </select>
                    </div>

                    {/* Filtro de Categoria */}
                    <div className={styles.status_filter_wrapper} style={{ flex: 1, minWidth: '160px' }}>
                        <h3>Categoria:</h3>
                        <select
                            value={categoryFilter}
                            onChange={(e) => setCategoryFilter(e.target.value)}
                            className={styles.status_select}
                            style={{ width: '100%' }}
                        >
                            <option value="Todos">Todas as categorias</option>
                            <option value="Agapornis">Agapornis</option>
                            <option value="Bicudo">Bicudo</option>
                            <option value="Calopsita">Calopsita</option>
                            <option value="Canário De Canto">Canário De Canto</option>
                            <option value="Canário De Cor">Canário De Cor</option>
                            <option value="Canário De Porte">Canário De Porte</option>
                            <option value="Canário sem Raça Definida (SRD)">Canário Sem Raça Definida (SRD)</option>
                            <option value="Curió">Curió</option>
                            <option value="Mais Exóticos">Mais Exóticos</option>
                            <option value="Mais Psitacídeos">Mais Psitacídeos</option>
                            <option value="Periquito">Periquito</option>
                            <option value="Periquito ondulado Australiano">Periquito Ondulado Australiano</option>
                            <option value="Pintassilgo">Pintassilgo</option>
                            <option value="Outros">Outros</option>
                        </select>
                    </div>
                </div>


            </div>

            <div className={styles.birds_list}>
                {filteredBirds.length > 0 ? (
                    filteredBirds.map((bird) => (
                        <div 
                            key={bird._id} 
                            className={styles.bird_row_card}
                            onClick={() => navigate(`/bird/${bird._id}`)}
                        >
                            <div className={`${styles.gender_icon} ${getGenderClass(bird.gender)}`}>
                                {getGenderIcon(bird.gender)}
                            </div>
                            <div className={styles.bird_summary}>
                                <div className={styles.title_status_row}>
                                    <h3>{bird.name}</h3>
                                    {bird.status && bird.status !== 'Ativo' && (
                                        <span className={`${styles.status_badge} ${styles['status_' + bird.status.toLowerCase()]}`}>
                                            {bird.status}
                                        </span>
                                    )}
                                </div>
                                <p>Anilha Direita: {bird.bird_band_right}</p>
                                <p>Anilha Esquerda: {bird.bird_band_left}</p>
                                <p>{bird.category}</p>
                                <p>{getGenderLabel(bird.gender)} {bird.color} {bird.race}</p>
                            </div>
                            <div className={styles.arrow_icon}>→</div>
                        </div>
                    ))
                ) : (
                    <div className={styles.empty_list}>
                        <p>Nenhuma ave encontrada.</p>
                    </div>
                )}
            </div>

            {/* Modal de Cadastro Principal */}
            {isCreateModalOpen && (
                <div className={styles.modal_overlay}>
                    <div className={styles.modal_content}>
                        <div className={styles.modal_header}>
                            <h2>Cadastrar Ave</h2>
                            <button className={styles.close_btn} onClick={() => setIsCreateModalOpen(false)}>✕</button>
                        </div>

                        {errorMessage && (
                            <div className={styles.error_alert_overlay}>
                                <div className={styles.error_alert_box}>
                                    <div className={styles.error_alert_icon}>⚠️</div>
                                    <h3>Atenção</h3>
                                    <p>{errorMessage}</p>
                                    <button 
                                        type="button" 
                                        className={styles.error_alert_btn} 
                                        onClick={() => setErrorMessage('')}
                                    >
                                        Entendi
                                    </button>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className={styles.form}>
                            <label>Aviário *</label>
                            <select name="aviaryId" value={formData.aviaryId} onChange={handleChange} required>
                                <option value="">Selecione um aviário</option>
                                {aviaries.map((av) => (
                                    <option key={av._id} value={av._id}>{av.name}</option>
                                ))}
                            </select>

                            <label>Nome</label>
                            <input type="text" name="name" value={formData.name} onChange={handleChange} />

                            <label>Anel Direito</label>
                            <input type="text" name="bird_band_right" value={formData.bird_band_right} onChange={handleChange} />

                            <label>Anel Esquerdo</label>
                            <input type="text" name="bird_band_left" value={formData.bird_band_left} onChange={handleChange} />

                            <label>Categoria *</label>
                            <select name="category" value={formData.category} onChange={handleChange} required>
                                <option value="Canário De Canto">Canário De Canto</option>
                                <option value="Canário De Cor">Canário De Cor</option>
                                <option value="Canário De Porte">Canário De Porte</option>
                                <option value="Canário sem Raça Definida (SRD)">Canário Sem Raça Definida (SRD)</option>
                                <option value="Agapornis">Agapornis</option>
                                <option value="Bicudo">Bicudo</option>
                                <option value="Calopsita">Calopsita</option>
                                <option value="Curió">Curió</option>
                                <option value="Mais Exóticos">Mais Exóticos</option>
                                <option value="Mais Psitacídeos">Mais Psitacídeos</option>
                                <option value="Periquito">Periquito</option>
                                <option value="Periquito ondulado Australiano">Periquito Ondulado Australiano</option>
                                <option value="Pintassilgo">Pintassilgo</option>
                                <option value="Outros">Outros</option>
                            </select>

                            <label>Raça</label>
                            <input type="text" name="race" value={formData.race} onChange={handleChange} />

                            <label>Cor</label>
                            <input type="text" name="color" value={formData.color} onChange={handleChange} />

                            <label>Sexo *</label>
                            <select name="gender" value={formData.gender} onChange={handleChange} required>
                                <option value="undefined">Indefinido</option>
                                <option value="male">Macho</option>
                                <option value="female">Fêmea</option>
                            </select>

                            <label>Data de Nascimento *</label>
                            <input type="date" name="birthday" value={formData.birthday} onChange={handleChange} required />

                            <label>Gaiola de Nascimento</label>
                            <select name="birthing_cage" value={formData.birthing_cage} onChange={handleChange}>
                                <option value="">Nenhuma / Não especificada</option>
                                {cages.map((cage) => (
                                    <option key={cage._id} value={cage._id}>
                                        {cage.title || `Gaiola ${cage.number}`}
                                    </option>
                                ))}
                            </select>

                            <label>Gaiola Atual</label>
                            <select name="current_cage" value={formData.current_cage} onChange={handleChange}>
                                <option value="">Nenhuma / Não especificada</option>
                                {cages.map((cage) => (
                                    <option key={cage._id} value={cage._id}>
                                        {cage.title || `Gaiola ${cage.number}`}
                                    </option>
                                ))}
                            </select>

                            {/* BOTÃO PARA SELECIONAR PAI */}
                            <label>Pai</label>
                            <button
                                type="button"
                                onClick={() => setParentModalType('father')}
                                style={{
                                    padding: '0.65rem',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                    backgroundColor: '#ffffff',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justify: 'space-between',
                                    alignItems: 'center',
                                    color: selectedFather ? '#0f172a' : '#64748b'
                                }}
                            >
                                <span>
                                    {selectedFather
                                        ? `${selectedFather.name} (Anilha: ${selectedFather.bird_band_right || ''} ${selectedFather.bird_band_left || ''})`
                                        : 'Selecione o Pai (Opcional)'}
                                </span>
                            </button>

                            {/* BOTÃO PARA SELECIONAR MÃE */}
                            <label>Mãe</label>
                            <button
                                type="button"
                                onClick={() => setParentModalType('mother')}
                                style={{
                                    padding: '0.65rem',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                    backgroundColor: '#ffffff',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justify: 'space-between',
                                    alignItems: 'center',
                                    color: selectedMother ? '#0f172a' : '#64748b'
                                }}
                            >
                                <span>
                                    {selectedMother
                                        ? `${selectedMother.name} (Anilha: ${selectedMother.bird_band_right || ''} ${selectedMother.bird_band_left || ''})`
                                        : 'Selecione a Mãe (Opcional)'}
                                </span>
                            </button>

                            <label>Status</label>
                            <select name="status" value={formData.status} onChange={handleChange}>
                                <option value="Ativo">Ativo</option>
                                <option value="Vendido">Vendido</option>
                                <option value="Falecido">Falecido</option>
                                <option value="Doado">Doado</option>
                            </select>

                            <div className={styles.modal_actions}>
                                <button type="button" onClick={() => setIsCreateModalOpen(false)} className={styles.btn_cancel}>Cancelar</button>
                                <button type="submit" className={styles.btn_submit}>Cadastrar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* MODAL DE BUSCA DE PAIS COM AJUSTES PARA TECLADO MOBILE */}
            {parentModalType && (
                <div 
                    className={styles.modal_overlay} 
                    style={{ 
                        zIndex: 1100, 
                        alignItems: 'flex-start', 
                        paddingTop: '10px',
                        overflowY: 'auto'
                    }}
                >
                    <div 
                        className={styles.modal_content} 
                        style={{ 
                            maxHeight: '92svh', 
                            display: 'flex', 
                            flexDirection: 'column',
                            borderRadius: '16px'
                        }}
                    >
                        <div className={styles.modal_header} style={{ marginBottom: '0.5rem', flexShrink: 0 }}>
                            <h2>{parentModalType === 'father' ? 'Selecionar Pai' : 'Selecionar Mãe'}</h2>
                            <button 
                                type="button"
                                className={styles.close_btn} 
                                onClick={() => {
                                    setParentModalType(null);
                                    setParentSearchTerm('');
                                }}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Campo de Pesquisa Fixo no Topo */}
                        <div className={styles.search_input_wrapper} style={{ marginBottom: '0.75rem', flexShrink: 0 }}>
                            <span className={styles.search_icon}>🔍</span>
                            <input
                                type="text"
                                placeholder="Pesquisar por nome ou anilha..."
                                value={parentSearchTerm}
                                onChange={(e) => setParentSearchTerm(e.target.value)}
                            />
                        </div>

                        {/* Lista de Opções Dinâmica que Encolhe conforme o Teclado Abre */}
                        <div 
                            className={styles.birds_list} 
                            style={{ 
                                flex: 1, 
                                overflowY: 'auto', 
                                minHeight: '120px', 
                                paddingRight: '2px' 
                            }}
                        >
                            <div 
                                className={styles.bird_row_card} 
                                onClick={() => handleSelectParent('')}
                                style={{ borderStyle: 'dashed', justifyContent: 'center' }}
                            >
                                <p style={{ margin: 0, color: '#64748b', fontWeight: 600 }}>Nenhum / Não informado</p>
                            </div>

                            {filteredParentOptions.length > 0 ? (
                                filteredParentOptions.map((b) => (
                                    <div
                                        key={b._id}
                                        className={styles.bird_row_card}
                                        onClick={() => handleSelectParent(b._id)}
                                        style={{
                                            border: (parentModalType === 'father' ? formData.father : formData.mother) === b._id ? '2px solid #2563eb' : '1px solid #e2e8f0'
                                        }}
                                    >
                                        <div className={`${styles.gender_icon} ${getGenderClass(b.gender)}`}>
                                            {getGenderIcon(b.gender)}
                                        </div>
                                        <div className={styles.bird_summary}>
                                            <h3>{b.name}</h3>
                                            <p>Anilha Direita: {b.bird_band_right || '-'}</p>
                                            <p>Anilha Esquerda: {b.bird_band_left || '-'}</p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className={styles.empty_text} style={{ textAlign: 'center', padding: '1rem' }}>
                                    Nenhuma ave encontrada com esse filtro.
                                </p>
                            )}
                        </div>

                        <div className={styles.modal_actions} style={{ marginTop: '0.75rem', flexShrink: 0 }}>
                            <button
                                type="button"
                                className={styles.btn_cancel}
                                onClick={() => {
                                    setParentModalType(null);
                                    setParentSearchTerm('');
                                }}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Bird;